/* @flow */

import React from 'react';
import Immutable from 'immutable';
import FontAwesome from 'react-fontawesome';
import PropTypes from '../util/prop_types';
import MenuListItem from './menu_list_item';
import MenuChecklistItem from './menu_checklist_item';

export default class MenuSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  static propTypes = {
    section: PropTypes.immutable.map.isRequired,
  }

  _onClick = () => {
    this.setState({collapsed: !this.state.collapsed});
  }

  _renderSubSections = () => {
    const { section } = this.props;
    return section.get('body').map((subSection, key) => {
      const type = subSection.get('type');
      if (type == "checklist") {
        const items = subSection.get('items').map((item, key) => {
          return (
            <MenuChecklistItem
              key={key}
              item={item} />
          );
        });
        return (
          <ul className="menu-checklist" key={key}>
            {items}
          </ul>
        );
      }
      else if (type == "list") {
        const items = subSection.get('items').map((item, key) => {
          return (
            <MenuListItem
              key={key}
              item={item} />
          );
        });
        return (
          <ul className="menu-list" key={key}>
            {items}
          </ul>
        );
      }
      else {
        return null;
      }
    });
  }

  render(): ?React.Element<any> {
    const { section } = this.props;

    const iconType = section.get('iconType');
    const icon = section.get('icon');
    const className = (this.state.collapsed) ? "menu-section collapsed" : "menu-section";
    const subSections = this._renderSubSections();

    return (
      <div
        className={className}
        aria-expanded={this.state.collapsed ? false : true}>
        <div
          className="menu-section-header"
          onClick={this._onClick}>
          <div
            className="menu-section-arrow">
            <FontAwesome
              name={this.state.collapsed ? "chevron-right" : "chevron-down"}
              fixedWidth />
          </div>
          <h3>
            {iconType == "fa" &&
              <div
                className="menu-section-icon">
                <FontAwesome
                  name={icon}
                  fixedWidth />
              </div>
            }
            {iconType == "img" &&
              <div
                className="menu-section-icon">
                <img src={icon} />
              </div>
            }
            {section.get('label')}
          </h3>
        </div>
        <div className="menu-section-body">
          {subSections}
        </div>
      </div>
    );
  }
}
